import { isApiError } from './is-api-error';
import { isAxiosError } from './is-axios-error';
import { maskedObject } from './masked-object';
export const enhanceError = (e, meta = {}, ...parsers) => {
    const exception = e instanceof Error ? e : new Error(JSON.stringify(e));
    return Object.assign(exception, meta, ...parsers.map((parser) => parser(exception)));
};
export const isNetworkError = (e) => 'network' in e;
export const extractErrorMeta = (e) => {
    const forbiddenKeys = ['network', 'request', 'response', 'toJSON'];
    const customMeta = maskedObject(Object.keys(e)
        .filter((key) => !forbiddenKeys.includes(key))
        .reduce((acc, key) => ({ ...acc, [key]: e[key] }), {}));
    const hasCustomMeta = Object.keys(customMeta).length;
    return {
        ...(isNetworkError(e) ? { network: e.network } : {}),
        ...(hasCustomMeta ? { errorDetails: customMeta } : {}),
        errorMessage: e.message,
    };
};
const extractNetworkContext = (e) => {
    if (isAxiosError(e) && !isNetworkError(e)) {
        const statusCode = Number(e?.response?.status);
        const endpoint = e?.response?.config?.url;
        const backendErrorContext = isApiError(e) ? e?.response?.data?.error : undefined;
        const backendMessage = backendErrorContext?.message;
        const request = e?.request;
        let { message } = e;
        if (backendMessage) {
            message = backendMessage;
        }
        if (statusCode) {
            message = `${message} [${statusCode}]`;
        }
        return { network: { statusCode, endpoint, backendErrorContext, request }, message };
    }
    return {};
};
export const createGlovoError = (e, meta = {}) => enhanceError(e, meta, extractNetworkContext);
//# sourceMappingURL=create-glovo-error.js.map